import { useNavigate } from 'react-router-dom'
import { PageNavigation } from '../../../../types/routing-types'
import { HandleSave } from '../../../hooks/use-edit-form'
import WellEditButtons from '../../wells/well-edit-buttons'

interface WellDetailsEditButtonsProps {
  urls: Omit<PageNavigation, 'saveAndReturnRoute'>
  handleSave: HandleSave
}

export default function WellDetailsEditButtons({ urls, handleSave }: WellDetailsEditButtonsProps) {
  const navigate = useNavigate()

  const baseNavigationState = {
    isProgrammaticTransition: true,
  }
  const saveNavigationState = {
    ...baseNavigationState,
    ...(urls.navigateToSaveRouteState && { ...urls.navigateToSaveRouteState }),
  }

  const saveAndContinueNavState = {
    ...baseNavigationState,
    ...(urls.navigateToSaveAndContinueRouteState && { ...urls.navigateToSaveAndContinueRouteState }),
  }

  return (
    <WellEditButtons
      actions={[
        {
          label: 'Save and continue',
          buttonStyle: 'primary',
          onClick: () =>
            handleSave(async (id, refetch) => {
              refetch && (await refetch())
              const navigateRoute = urls.saveAndContinueRoute(id)
              if (navigateRoute) {
                navigate(navigateRoute, { state: saveAndContinueNavState })
              }
            }),
        },
        {
          label: 'Save',
          buttonStyle: 'primary',
          onClick: () => {
            handleSave(async (id, refetch) => {
              refetch && (await refetch())
              urls.saveRouteNewId && navigate(urls.saveRouteNewId(id), { state: saveNavigationState })
            })
          },
        },
        {
          label: urls.cancelButtonLabel ?? 'Return to view',
          buttonStyle: 'text-action',
          onClick: () => navigate(urls.cancelRoute),
        },
      ]}
    />
  )
}
